import * as React from 'react';
import { IPaginatedLandingContent } from '../models/paginated-landing-content'


interface IProps {
    content: IPaginatedLandingContent;
}

export class LandingPageContent extends React.Component<IProps, any> {
    render() {


        const { content } = this.props;
        return (
            <div className="paginated-template-item">
                <div className="paginated-template-item-content">
                    <h4 className="paginated-template-item-title">
                        <a href={content.url}>{content.title}</a>
                    </h4>
                    <p className="paragraph-caption paginated-template-item-date"><strong>
                        <span>{content.date}</span>
                    </strong>
                    </p>
                    <p className="paragraph-caption paginated-template-item-desc">{content.description}</p>
                </div>
                {content.imageUrl
                    ? <img className="paginated-template-item-image" src={content.imageUrl} />
                    : null
                }
            </div>
        );
    }
}